module.exports = __webpack_public_path__ + "static/7-5ddeeeeac7cd1dca14382ea6aaa55c37.jpeg";